// /client/customer/src/utils/reservation/by-service/fetchOpenDatesForServiceReserve.ts
import apiConfig from '../../../apiConfig';

export type FetchOpenDatesForServiceReserveResponse = {
  open_dates: string[]; // 'YYYY-MM-DD'
};

export const fetchOpenDatesForServiceReserve = async (
  storeId: number,
  serviceIds: number[],
  days = 30,
): Promise<string[]> => {
  if (!Number.isFinite(storeId) || storeId <= 0) throw new Error('Invalid storeId');
  if (!Array.isArray(serviceIds) || serviceIds.length === 0) throw new Error('serviceIds is required');
  if (!Number.isFinite(days) || days <= 0) throw new Error('Invalid days');

  const url = new URL(`${apiConfig.baseURL}/api/customer-app/reservation/by-service/open-dates`);
  url.searchParams.set('store_id', String(storeId));
  url.searchParams.set('service_ids', serviceIds.join(','));
  url.searchParams.set('days', String(days));

  const res = await fetch(url.toString(), { method: 'GET' });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to fetch open dates');
  }

  const data = (await res.json()) as FetchOpenDatesForServiceReserveResponse;
  return Array.isArray(data.open_dates) ? data.open_dates : [];
};
